"use client";
import isEmpty from "lodash/isEmpty";
import React, { useEffect, useMemo } from "react";

import SelectDropdown from "@stadium/ui/src/components/form/SelectDropdown";

import styles from "./main.module.scss";

export const CurrencySelector = ({
  initCurrencyId,
  className = "",
  currencies,
  currency,
  setCurrency,
  wrapperClassName,
  ...rest
}) => {
  const CURRENCIES = useMemo(
    () =>
      currencies.map((currency) => ({ ...currency, text: currency.code, value: currency.code })),
    [currencies],
  );

  const initCurrencyIndex = useMemo(
    () => CURRENCIES.findIndex(({ id }) => id == initCurrencyId),
    [CURRENCIES, initCurrencyId],
  );

  useEffect(() => {
    if (!isEmpty(CURRENCIES) && initCurrencyId) setCurrency(CURRENCIES[initCurrencyIndex]);
  }, [initCurrencyIndex]);

  const handleCurrencySelect = ({ value }) => {
    setCurrency(CURRENCIES.find((currency) => currency.value === value));
  };

  const renderDropdown = () => {
    return (
      <div className={className}>
        <SelectDropdown
          isSearchClearable
          options={CURRENCIES}
          showSearchFilter
          searchfilterOptions={{
            placeholder: "Search by currency",
            attributes: ["code", "name"],
          }}
          onSelect={handleCurrencySelect}
          value={currency?.code}
          text={currency?.code}
          renderLabel={(option) => <div>{option.label}</div>}
          parentLabel="Currency"
          className={`${styles.currencyDropdownWrappper} ${wrapperClassName}`}
          toggleClass={styles.currencyDropdownToggler}
          menuClass={`${styles.withSearch} rightAlign`}
          overlayClass={`${styles.dropDownOverlay} overlay`}
          wrapperClassName={styles.searchGroup}
          {...rest}
        />
      </div>
    );
  };

  return renderDropdown();
};

export default CurrencySelector;
